module.exports = __webpack_public_path__ + "assets/failure-smiley.svg";